import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-region-view',
    template: `
    <small class="tag">
      <ng-container [ngSwitch]="code">
        <ng-container *ngSwitchCase="'01'">город Астана</ng-container>
        <ng-container *ngSwitchCase="'0101'">город Астана - Алматинский район</ng-container>
        <ng-container *ngSwitchCase="'0102'">город Астана - Байконурский район</ng-container>
        <ng-container *ngSwitchCase="'0103'">город Астана - Есильский район</ng-container>
        <ng-container *ngSwitchCase="'0104'">город Астана - Сарыаркинский район</ng-container>
        <ng-container *ngSwitchCase="'0105'">город Астана - Нуринский район</ng-container>
        <ng-container *ngSwitchCase="'02'">город Алматы</ng-container>
        <ng-container *ngSwitchCase="'0201'">город Алматы - Алатауский район</ng-container>
        <ng-container *ngSwitchCase="'0202'">город Алматы - Алмалинский райо</ng-container>
        <ng-container *ngSwitchCase="'0203'">город Алматы - Аузовский район</ng-container>
        <ng-container *ngSwitchCase="'0204'">город Алматы - Бостандыкский район</ng-container>
        <ng-container *ngSwitchCase="'0205'">город Алматы - Жетысуйский район</ng-container>
        <ng-container *ngSwitchCase="'0206'">город Алматы - Медеуский район</ng-container>
        <ng-container *ngSwitchCase="'0207'">город Алматы - Наурызбайский район</ng-container>
        <ng-container *ngSwitchCase="'0208'">город Алматы - Турксибский район</ng-container>
        <ng-container *ngSwitchCase="'03'">Акмолинская область</ng-container>
        <ng-container *ngSwitchCase="'04'">Актюбинская область</ng-container>
        <ng-container *ngSwitchCase="'05'">Алматинская область</ng-container>
        <ng-container *ngSwitchCase="'06'">Атырауская область</ng-container>
        <ng-container *ngSwitchCase="'07'">Западно-Казахстанская область</ng-container>
        <ng-container *ngSwitchCase="'08'">Жамбылская область</ng-container>
        <ng-container *ngSwitchCase="'09'">Карагандинская область</ng-container>
        <ng-container *ngSwitchCase="'10'">Костанайская область</ng-container>
        <ng-container *ngSwitchCase="'11'">Кызылординская область</ng-container>
        <ng-container *ngSwitchCase="'12'">Мангистауская область</ng-container>
        <ng-container *ngSwitchCase="'13'">Туркестанская область</ng-container>
        <ng-container *ngSwitchCase="'14'">Павлодарская область</ng-container>
        <ng-container *ngSwitchCase="'15'">Северо-Казахстанская область</ng-container>
        <ng-container *ngSwitchCase="'16'">Восточно-казахстанская область</ng-container>
        <ng-container *ngSwitchCase="'17'">город Шымкент</ng-container>
        <ng-container *ngSwitchCase="'18'">Область Абай</ng-container>
        <ng-container *ngSwitchCase="'19'">Область Жетысу</ng-container>
        <ng-container *ngSwitchCase="'20'">Область Ұлытау</ng-container>
        <ng-container *ngSwitchDefault>{{code}}</ng-container>
      </ng-container>
    </small>
  `,
    styles: `
      .tag {
        color: rgba(0, 0, 0, 0.85);
        font-variant: tabular-nums;
        list-style: none;
        font-feature-settings: "tnum";
        height: auto;
        margin-right: 8px;
        padding: 0 7px;
        font-size: 12px;
        line-height: 20px;
        background: #fafafa;
        border: 1px solid #d9d9d9;
        border-radius: 2px;
        opacity: 1;
        transition: all 0.3s;
        display: inline-block;
      }
    `,
    imports: [
        CommonModule,
    ]
})
export class RegionViewComponent {

  @Input()
  code?: string;
}
